import styled from 'styled-components';

export const ProductQuantityAdderWrapper = styled.div`
  > strong {
    display: block;
  }
`;
